<template>
    <div>
        <div class="filter-block">
            <div class="filter-block-left">
                <i class="fa fa-filter" style="margin-right: 10px;"></i>
                <el-input v-model="filter.keyword"  @input="oninput" size="mini" placeholder="请输入搜索关键词或备注" style="width: 200px;margin-right: 5px;" clearable></el-input>
                <el-tooltip class="item" effect="dark" placement="right-end">
                    <div slot="content">
                        搜索包含您在此处输入的单词的关键字短语。<br/>
                        <!-- 也可以通过添加在一个你想漏掉的词前面。<br/>
                        例如，iphone-case 将显示包含单词<br/>
                        “iphone”的所有关键字短语，<br/>
                        但不包括任何包含单词“case”的关键字短语。 -->
                    </div>
                    <i class="far fa-question-circle refine-search-info" style="color: #fff;margin-right: 5px;"></i>
                </el-tooltip>
                <el-popover
                    class="button-star"
                    placement="bottom-start" 
                    title
                    :popper-append-to-body="false"
                    :append-to-body="false"
                    popper-class="select-popper"
                    trigger="click">
                    <div style="width: 150px;">
                        <el-checkbox-group v-model="checkList" @change="groupChange">
                            <div class="checkbox-div" v-for="(item, i) in this.$store.state.admin.star_arr" :key="i">
                                <el-checkbox :label="item">
                                    <i class="el-icon-star-on icon-star" style="font-size: 20px;" :style="{'color': item.color}"></i>
                                    <span style="width: 100px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{item.remark}}</span>
                                </el-checkbox>
                            </div>
                        </el-checkbox-group>
                        <div v-if="checkList.length != 0" @click="onEmpty()" class="empty">清空</div>
                    </div>
                    <div slot="reference">
                        <el-button size="mini">
                            <i v-if="checkList.length == 0" class="el-icon-star-on" style="color: #6a6c6f !important;font-size: 18px;"></i>
                            <span v-else>
                                <span v-for="(checkListItem, index) in checkList" :key="index">
                                    <i class="el-icon-star-on" style="font-size: 18px;" :style="{'color': checkListItem.color}"></i>
                                </span>
                            </span>
                            <i class="el-icon-caret-bottom caret-bottom" style="color: #6a6c6f !important;font-size: 14px;"></i>
                        </el-button>
                    </div>
                </el-popover>
            </div>
            <div>
                <el-button v-if="KeywordSelection.length != 0" @click="copyKeyword" type="primary" size="mini" icon="el-icon-document-copy">复制选择</el-button>
                <el-button size="mini" icon="el-icon-refresh" @click="onReset"></el-button>
            </div>
        </div>
        <el-table
            v-loading="loading"
            :data="list"
            :header-cell-style="{background:'#d1e1ff','font-size':'12px'}"
            @selection-change="handleSelectionChange"
            @sort-change="handleSortChange"
            size="mini"
            ref="multipleTables">
            <el-table-column
                :resizable="false"
                label="#"
                sortable="custom"
                prop="index"
                width="52"
                align="center">
                <template slot-scope="scope">
                    <div>{{scope.row.index}}</div>
                </template>
            </el-table-column>
            <el-table-column
                type="selection"
                width="40"
                align="center">
            </el-table-column>
            <el-table-column
                :resizable="false"
                :render-header="renderHeader"
                width="66"
                min-width="250"
                sortable="custom"
                prop="tag_id"
                align="center">
                <template slot-scope="scope">
                    <div>
                        <i class="el-icon-star-on icon-star" style="font-size: 20px;cursor: pointer;" :style="{'color': scope.row.tag_color}"></i>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                sortable="custom"
                label="关键词"
                prop="keyword"
                min-width="160">
                <template slot-scope="scope">
                    <div style="word-break: break-word !important;">{{scope.row.keyword}}</div>
                    <div style="display: flex;justify-content:space-between;">
                        <div v-if="scope.row.asin != null" @click="edirectToAsin(scope.row)" style="cursor: pointer;color: rgb(52, 73, 94);">
                            <i class="el-icon-s-promotion" style="margin-right:5px;"></i>{{ scope.row.asin }}
                        </div>
                        <div v-if="scope.row.choice == 1" class="amazon-choice-badge">Amazon's <span>Choice</span></div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                align="center"
                width="140"
                label="搜索趋势">
                <template slot-scope="scope">
                    <div v-loading="loadingkeyword_tracker"  :id="'keyword_tracker' + scope.row.id" @click="oncharts_keyword(scope.row)" class="chart spinner_div"></div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                align="center"
                sortable="custom"
                width="100"
                prop="last_show_num"
                label="最近搜索量">
                <template slot-scope="scope">
                    <span>{{scope.row.last_show_num}}</span>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                sortable="custom"
                prop="remark"
                label="备注"
                min-width="60">
                <template slot-scope="scope">
                    <div>{{scope.row.remark}}</div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                label="竞品数量"
                sortable="custom"
                prop="competing_products"
                align="center"
                min-width="60">
                <template slot-scope="scope">
                    <div v-if="scope.row.competing_products"> > {{scope.row.competing_products}} </div>
                    <div v-else style="color: #dc3545!important;"> - </div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                label="排名"
                min-width="60"
                sortable="custom"
                prop="rank"
                align="center">
                <template slot-scope="scope">
                    <div @click="oncharts(scope.row)" style="cursor: pointer;">
                        <div v-if="scope.row.rank == null" style="font-size: 12px;"></div>
                        <div v-else-if="scope.row.rank == -1" style="font-size: 12px;">> 306</div>
                        <div v-else style="font-size: 12px;">{{scope.row.rank}}</div>
                        <span v-if="scope.row.rank_delta == null || scope.row.rank_delta == 0" class="position-delta" style="color: #dc3545!important;">-</span>
                        <span v-if="scope.row.rank_delta < 0" class="position-delta" style="color: #dc3545!important"><i class="el-icon-top"></i> {{ scope.row.rank_delta * -1 }}</span>
                        <span v-if="scope.row.rank_delta > 0" class="position-delta" style="color: #62cb31 !important"><i class="el-icon-bottom"></i> {{ scope.row.rank_delta }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                align="center"
                width="140"
                label="关键词趋势">
                <template slot-scope="scope">
                    <div v-loading="loadingWorkload"  :id="'workload' + scope.row.id" @click="oncharts(scope.row)" class="chart spinner_div"></div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                v-if="isRanking"
                align="center"
                min-width="60"
                label="相对排名">
                <template slot-scope="scope">
                    <div v-loading="loadingRanking" @click="oncharts_rank(scope.row)" style="cursor: pointer;" class="spinner_div">
                        <div v-if="scope.row.rank_relative == null" style="font-size: 12px;"> - </div>
                        <div v-else style="font-size: 12px;">{{ scope.row.rank_relative	}}/{{data.competitors.length + 1}}</div>
                        <span v-if="scope.row.rank_relative_delta == null || scope.row.rank_relative_delta == 0" class="position-delta" style="color: #dc3545!important;">-</span>
                        <span v-else-if="scope.row.rank_relative_delta > 0" class="position-delta" style="color: #62cb31 !important;"><i class="el-icon-bottom"></i> {{ scope.row.rank_relative_delta }}</span>
                        <span v-else-if="scope.row.rank_relative_delta < 0" class="position-delta" style="color: #dc3545 !important;"><i class="el-icon-top"></i> {{ scope.row.rank_relative_delta * -1 }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                v-if="isRanking"
                align="center"
                min-width="60"
                label="排名平均值">
                <template slot-scope="scope">
                    <div v-loading="loadingRanking" @click="oncharts(scope.row)" style="cursor: pointer;" class="spinner_div">
                        <div v-if="scope.row.rank_avg == null" style="font-size: 12px;"> - </div>
                        <div v-else style="font-size: 12px;">{{ scope.row.rank_avg	}}</div>
                        <span v-if="scope.row.rank_avg_delta == null || scope.row.rank_avg_delta == 0" class="position-delta" style="color: #dc3545!important;">-</span>
                        <span v-else-if="scope.row.rank_avg_delta > 0" class="position-delta" style="color: #62cb31 !important;"><i class="el-icon-bottom"></i> {{ scope.row.rank_avg_delta }}</span>
                        <span v-else-if="scope.row.rank_avg_delta < 0" class="position-delta" style="color: #dc3545 !important;"><i class="el-icon-top"></i> {{ scope.row.rank_avg_delta * -1 }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                v-if="isRanking"
                align="center"
                min-width="82"
                label="参与排名的ASIN数量">
                <template slot-scope="scope">
                    <div v-loading="loadingRanking" @click="oncharts_asin(scope.row)" style="cursor: pointer;" class="spinner_div">
                        <div v-if="scope.row.rank_count == null" style="font-size: 12px;">-</div>
                        <div v-else style="font-size: 12px;">{{ scope.row.rank_count}}/{{data.competitors.length + 1}}</div>
                        <span v-if="scope.row.rank_count_delta == null || scope.row.rank_count_delta == 0" class="position-delta" style="color: #dc3545!important;">-</span>
                        <span v-else-if="scope.row.rank_count_delta > 0" class="position-delta" style="color: #62cb31 !important;"><i class="el-icon-bottom"></i> {{ scope.row.rank_count_delta }}</span>
                        <span v-else-if="scope.row.rank_count_delta < 0" class="position-delta" style="color: #dc3545 !important;"><i class="el-icon-top"></i> {{ scope.row.rank_count_delta * -1 }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                label="广告排名"
                sortable="custom"
                prop="ad_rank"
                min-width="60"
                align="center">
                <template slot-scope="scope">
                    <div @click="oncharts_ad(scope.row)" style="cursor: pointer;">
                        <div v-if="scope.row.ad_rank == null" style="font-size: 12px;"></div>
                        <div v-else-if="scope.row.ad_rank == -1" style="font-size: 12px;">> 96</div>
                        <div v-else style="font-size: 12px;">{{scope.row.ad_rank}}</div>
                        <span v-if="scope.row.ad_rank_delta == null || scope.row.ad_rank_delta == 0" class="position-delta" style="color: #dc3545!important;">-</span>
                        <span v-if="scope.row.ad_rank_delta < 0" class="position-delta" style="color: #dc3545!important"><i class="el-icon-top"></i> {{ scope.row.ad_rank_delta * -1 }}</span>
                        <span v-if="scope.row.ad_rank_delta > 0" class="position-delta" style="color: #62cb31 !important"><i class="el-icon-bottom"></i> {{ scope.row.ad_rank_delta }}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                label="广告页码"
                min-width="70"
                align="center">
                <template slot-scope="scope">
                    <div style="">
                        <div>
                            <span v-if="scope.row.ad_page == null || scope.row.ad_page < 0" style="font-size: 12px;margin-right: 5px;">-</span>
                            <span v-else style="font-size: 12px;margin-right: 5px;">{{scope.row.ad_page}}</span>
                            <span v-if="scope.row.ad_page_delta == null || scope.row.ad_page_delta == 0" class="position-delta" style="color: #dc3545!important;">-</span>
                            <span v-if="scope.row.ad_page_delta < 0" class="position-delta" style="color: #dc3545!important"><i class="el-icon-top"></i> {{ scope.row.ad_page_delta * -1 }}</span>
                            <span v-if="scope.row.ad_page_delta > 0" class="position-delta" style="color: #62cb31 !important"><i class="el-icon-bottom"></i> {{ scope.row.ad_page_delta }}</span>
                        </div>
                        <div>
                            <div v-if="scope.row.ad_is_top == 1" class="amazon-choice-badge" style="margin-left: 30px;background: #e47911;">TOP</div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column
                :resizable="false"
                align="center"
                width="140"
                label="更新时间(中国时区)">
                <template slot-scope="scope">
                    <span>{{ scope.row.updated_at }}</span>
                </template>
            </el-table-column>
            <el-table-column
                width="80"
                label="操作">
                <template slot-scope="scope">
                    <div @click="oncharts(scope.row)" title="显示图形" class="fa_icon_ line">
                        <icon-svg :icon-class="'curve1'"></icon-svg>
                    </div>
                    <div  @click="edirectToKeyword(scope.row)" title="按此关键字显示亚马逊搜索结果" class="fa_icon_ line">
                        <icon-svg :icon-class="'amazon'"></icon-svg>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[20, 50, 100]"
            :total="query.total"
            background
            style="margin-top: 5px; margin-bottom: 5px"
            layout="total, sizes, prev, pager, next">
        </el-pagination>
        <charts ref="charts" :asin="data.asin" :visible="ctrl.chartsFolderVisible" :formData="formData" :title="ctrl.dialogTitle" :charts_keyword="charts_keyword" :charts_id="charts_id" @close-callback="closeCllback"></charts>
        <charts-ad ref="charts_ad" :visible="ctrl.charts_adVisible" :formData="formData" :title="ctrl.dialogTitle" :charts_keyword="charts_keyword" :charts_id="charts_id" @close-callback="closeCllback"></charts-ad>
        <charts-asin ref="charts_asin" :visible="ctrl.charts_asinVisible" :formData="formData" :title="ctrl.dialogTitle" :charts_keyword="charts_keyword" :charts_id="charts_id" @close-callback="closeCllback"></charts-asin>
        <charts-rank ref="charts_rank" :visible="ctrl.charts_rankVisible" :formData="formData" :title="ctrl.dialogTitle" :charts_keyword="charts_keyword" :charts_id="charts_id" @close-callback="closeCllback"></charts-rank>
        <charts-keyword ref="charts_keyword_" :admin_id="admin_id" :visible="ctrl.charts_keywordVisible" :title="ctrl.dialogTitle" :charts_keyword="charts_keyword" :charts_id="charts_id" @close-callback="closeCllback"></charts-keyword>
    </div>
</template>
<script>
import * as api from "@/api/Product/Product";
import { link_us } from "@/utils/method";
import * as Highcharts from "highcharts";
import Charts from "./charts";
import ChartsAd from "../keyword/charts_ad";
import ChartsAsin from "../keyword/charts_asin";
import ChartsRank from "../keyword/charts_rank";
import ChartsKeyword from "./charts_keyword";
export default {
    components: {
        Charts,
        ChartsAd,
        ChartsAsin,
        ChartsRank,
        ChartsKeyword
    },
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        admin_id: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            loading: false,
            loadingRanking: false,
            loadingWorkload: false,
            loadingkeyword_tracker: false,
            isRanking: false,
            list: [],
            checkList: [],
            star_arr: [],
            multipleSelection: [],
            KeywordSelection: [],
            ctrl: {
                charts_adVisible: false,
                charts_asinVisible: false,
                charts_rankVisible: false,
                charts_keywordVisible: false,
                chartsFolderVisible: false
            },
            query: {
                page: 1,
                limit: 20
            },
            charts_id: "0",
            charts_keyword: "",
            filter: {},
            requestCount: 0,
            order: {},
            formData: {}
        };
    },
    // watch: {
    //     list: function() {
    //         this.$nextTick(function() {
    //             for (let i = 0; i < this.list.length; i++) {
    //                 if (this.list[i].trend) {
    //                     this.workload(
    //                         "workload" + this.list[i].id,
    //                         this.list[i].trend
    //                     );
    //                 }
    //                 if (this.list[i].show_num_sum) {
    //                     this.workload_tracker(
    //                         "keyword_tracker" + this.list[i].id,
    //                         this.list[i]
    //                     );
    //                 }
    //             }
    //         });
    //     }
    // },
    methods: {
        getList() {
            let obj = this.query;
            obj.product_id = this.data.id;
            obj.admin_id = this.$route.query.admin_id;
            obj.filter = this.filter;
            obj.order = this.order;
            let count = this.requestCount;
            count = count + 1;
            this.requestCount = count;
            this.loading = true;
            this.loadingWorkload = true;
            this.loadingkeyword_tracker = true;
            api.keyword_page_list(obj)
                .then(async res => {
                    this.loading = false;
                    if (res.code === 0) {
                        if (this.requestCount != count) return;
                        this.list = res.data.list;
                        this.query.page = res.data.page;
                        this.query.total = res.data.total;
                        this.query.total_page = res.data.total_page;
                        let arr = [];
                        let arr_key = [];
                        let that = this;
                        let list = JSON.parse(JSON.stringify(that.list));
                        for (let i = 0; i < list.length; i++) {
                            arr.push(list[i].id);
                            arr_key.push(list[i].keyword);
                        }
                        if (this.data.competitors.length != 0) {
                            this.isRanking = true;
                            this.loadingRanking = true;
                            this.getRanking(this.data.id, arr, count);
                        } else {
                            this.isRanking = false;
                        }
                        if (arr.length > 0) {
                            this.getGraph(arr, count);
                        } else {
                            this.loadingWorkload = false;
                        }
                        if (arr_key.length > 0) {
                            this.trend_batch(arr_key, count);
                        } else {
                            this.loadingkeyword_tracker = false;
                        }
                    } else {
                        this.loadingWorkload = false;
                        this.loadingkeyword_tracker = false;
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.loadingWorkload = false;
                    this.loadingkeyword_tracker = false;
                });
        },
        //获取关键词曲线图数据
        async trend_batch(arr, count) {
            let that = this;
            if (that.requestCount != count) {
                return (that.loadingkeyword_tracker = false);
            }
            await api
                .search_trend_batchs({
                    keywords: arr,
                    admin_id: this.admin_id,
                    country_code: this.data.country_code
                })
                .then(res => {
                    that.loadingkeyword_tracker = false;
                    if (that.requestCount != count) return;
                    let list = JSON.parse(JSON.stringify(that.list));
                    if (res.code === 0) {
                        let data = res.data;
                        for (let i = 0; i < list.length; i++) {
                            list[i].show_num_sum_date =
                                data[list[i].keyword].date;
                            list[i].show_num_sum =
                                data[list[i].keyword].show_num_sum;
                        }
                        that.list = list;
                        for (let i = 0; i < that.list.length; i++) {
                            if (that.list[i].show_num_sum) {
                                that.workload_tracker(
                                    "keyword_tracker" + that.list[i].id,
                                    that.list[i]
                                );
                            }
                        }
                    } else {
                        that.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    that.loadingkeyword_tracker = false;
                });
        },
        //获取曲线图数据
        async getRanking(id, arr, count) {
            let that = this;
            if (that.requestCount != count) {
                return (that.loadingRanking = false);
            }
            await api
                .competitors_ranking({ product_id: id, keyword_ids: arr })
                .then(res => {
                    that.loadingRanking = false;
                    if (that.requestCount != count) return;
                    let list = JSON.parse(JSON.stringify(that.list));
                    if (res.code === 0) {
                        let data = res.data;
                        for (let i = 0; i < list.length; i++) {
                            list[i].rank_avg = data[list[i].id].rank_avg;
                            list[i].rank_count = data[list[i].id].rank_count;
                            list[i].rank_relative =
                                data[list[i].id].rank_relative;
                            list[i].rank_avg_delta =
                                data[list[i].id].rank_avg_delta;
                            list[i].rank_count_delta =
                                data[list[i].id].rank_count_delta;
                            list[i].rank_relative_delta =
                                data[list[i].id].rank_relative_delta;
                        }
                        that.list = list;
                    } else {
                        that.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.loadingRanking = false;
                });
        },
        handleSortChange(val) {
            let obj = {};
            if (val.order == "ascending") {
                obj.desc = 0;
                obj.field = val.prop;
            } else if (val.order == "descending") {
                obj.desc = 1;
                obj.field = val.prop;
            }
            this.order = obj;
            this.getList();
        },
        //筛选星级
        groupChange(data) {
            let arr = [];
            data.map(v => {
                arr.push(v.id);
            });
            this.filter.tags = arr;
            this.getList();
        },
        //获取曲线图数据
        async getGraph(arr, count) {
            let that = this;
            if (that.requestCount != count) {
                return (that.loadingWorkload = false);
            }
            await api
                .trend_batch({ keyword_ids: arr })
                .then(res => {
                    that.loadingWorkload = false;
                    if (that.requestCount != count) return;
                    let list = JSON.parse(JSON.stringify(that.list));
                    if (res.code === 0) {
                        let data = res.data;
                        for (let i = 0; i < list.length; i++) {
                            list[i].trend = data[list[i].id];
                        }
                        that.list = list;
                        for (let i = 0; i < that.list.length; i++) {
                            if (that.list[i].trend) {
                                that.workload(
                                    "workload" + that.list[i].id,
                                    that.list[i].trend
                                );
                            }
                        }
                    } else {
                        that.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                })
                .catch(() => {
                    that.loadingWorkload = false;
                });
        },
        renderHeader(h) {
            return h("span", [
                h("i", {
                    class: "el-icon-star-on",
                    style:
                        "color: #555;font-size: 20px;transform: translateY(3px)"
                })
            ]);
        },
        //跳转到亚马逊产品页面
        edirectToAsin(data) {
            let url =
                link_us(this.data.country_code) +
                "dp/" +
                data.asin +
                "?th=1&psc=1";
            window.open(url, "_blank");
        },
        //跳转到亚马逊关键词页面
        edirectToKeyword(data) {
            let str = data.keyword.replace(/[\s]+/g, "+");
            let url = link_us(this.data.country_code) + "s?k=" + str;
            window.open(url, "_blank");
        },
        //打开曲线图
        oncharts(data) {
            let that = this;
            this.charts_id = data.id;
            this.charts_keyword = data.keyword;
            this.formData = this.data;
            this.ctrl.dialogTitle = `${this.data.asin} : ${data.keyword}`;
            this.ctrl.chartsFolderVisible = true;
            setTimeout(function() {
                that.$refs.charts.getList(data.id, 30);
            }, 100);
        },
        //打开关键词曲线图
        oncharts_keyword(data) {
            let that = this;
            this.charts_id = data.id;
            this.charts_keyword = data.keyword;
            this.ctrl.dialogTitle = `${data.keyword} 的搜索趋势图`;
            this.ctrl.charts_keywordVisible = true;
            setTimeout(function() {
                that.$refs.charts_keyword_.getList(
                    data.keyword,
                    30,
                    that.admin_id,
                    that.data.country_code
                );
            }, 100);
        },
        //打开曲线图广告
        oncharts_ad(data) {
            let that = this;
            this.charts_id = data.id;
            this.charts_keyword = data.keyword;
            this.formData = this.data;
            this.ctrl.dialogTitle = `${this.data.asin} : ${
                data.keyword
            } (广告排名)`;
            this.ctrl.charts_adVisible = true;
            setTimeout(function() {
                that.$refs.charts_ad.getList(data.id, 30);
            }, 100);
        },
        //打开曲线图广告(asin)
        oncharts_rank(data) {
            let that = this;
            this.charts_id = data.id;
            this.charts_keyword = data.keyword;
            this.formData = this.data;
            this.ctrl.dialogTitle = `${this.data.asin} : ${
                data.keyword
            } (相对于竞争对手的排名)`;
            this.ctrl.charts_rankVisible = true;
            setTimeout(function() {
                that.$refs.charts_rank.getList(data.id, 30);
            }, 100);
        },
        //打开曲线图广告(rank)
        oncharts_asin(data) {
            let that = this;
            this.charts_id = data.id;
            this.charts_keyword = data.keyword;
            this.formData = this.data;
            this.ctrl.dialogTitle = `${this.data.asin} : ${
                data.keyword
            } (有排名的ASIN数量)`;
            this.ctrl.charts_asinVisible = true;
            setTimeout(function() {
                that.$refs.charts_asin.getList(data.id, 30);
            }, 100);
        },
        // 数组按换行符拼接成字符串
        arr_str(arr) {
            let str = "";
            if (arr.length != 0) {
                for (let i = 0; i < arr.length; i++) {
                    str += arr[i] + "\n";
                }
            }
            return str;
        },
        //复制关键词
        copyKeyword() {
            const input = document.createElement("textarea");
            input.value = this.arr_str(this.KeywordSelection);
            document.body.appendChild(input);
            input.select();
            document.execCommand("Copy");
            document.body.removeChild(input);
        },
        //搜索
        oninput(val) {
            let that = this;
            clearTimeout(this.timeout);
            that.timeout = setTimeout(() => {
                that.query.page = 1;
                that.filter.keyword = val;
                that.getList();
            }, 800);
        },
        //多选框
        handleSelectionChange(val) {
            let arr = [];
            let Keyword = [];
            val.map(v => {
                arr.push(v.id);
                Keyword.push(v.keyword);
            });
            this.multipleSelection = arr;
            this.KeywordSelection = Keyword;
        },
        //刷新
        onReset() {
            this.list = [];
            this.getList();
        },
        //清空星星
        onEmpty() {
            this.checkList = [];
            this.filter.tags = [];
            this.getList();
        },
        workload(id_name, data) {
            let workload_id = document.getElementById(id_name);
            let dates = data.date;
            let datas = [];
            for (let i = 0; i < data.rank.length; i++) {
                datas.push(data.rank[i] == null ? null : 306 - data.rank[i]);
            }
            this.sparkLine(workload_id, datas, dates, 1);
        },
        workload_tracker(id_name, data) {
            let workload_id = document.getElementById(id_name);
            let datas = [];
            for (let i = 0; i < data.show_num_sum.length; i++) {
                datas.push(
                    data.show_num_sum[i] == null
                        ? null
                        : data.show_num_sum[i] * -1
                );
            }
            this.sparkLine(workload_id, datas, data.show_num_sum_date, 2);
        },
        sparkLine(div, datas, dates, index) {
            var options = {
                chart: {
                    borderWidth: 0,
                    type: "area",
                    margin: [8, 40, 8, 10],
                    width: 120,
                    height: 36,
                    style: {
                        overflow: "visible"
                    },
                    skipClone: true
                },
                title: {
                    text: null
                },
                credits: {
                    enabled: false
                },
                xAxis: {
                    categories: dates,
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    startOnTick: false,
                    endOnTick: false,
                    tickPositions: [],
                    tickWidth: 0,
                    lineColor: "#fff"
                },
                yAxis: {
                    reversed: index == 1 ? false : true,
                    labels: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    minPadding: 0,
                    startOnTick: false,
                    endOnTick: false,
                    tickPositions: []
                },
                legend: {
                    enabled: false
                },
                exporting: { enabled: false },
                tooltip: {
                    formatter: function() {
                        if (index == 1) {
                            return `<span style="font-size: 10px;">${
                                this.x
                            }</span><br/><b>${306 - this.y}</b>`;
                        }
                        if (index == 2) {
                            return `<span style="font-size: 10px;">${
                                this.x
                            }</span><br/><b>${this.y * -1}</b>`;
                        }
                    },
                    hideDelay: 0,
                    outside: true
                },
                series: [{ data: datas }],
                plotOptions: {
                    series: {
                        animation: false,
                        lineWidth: 1,
                        shadow: false,
                        states: {
                            hover: {
                                lineWidth: 1
                            }
                        },
                        marker: {
                            radius: 1,
                            states: {
                                hover: {
                                    radius: 2
                                }
                            }
                        },
                        fillOpacity: 0.25
                    },
                    column: {
                        negativeColor: "#910000",
                        borderColor: "silver"
                    }
                }
            };
            return new Highcharts.Chart(div, options);
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val;
            this.getList();
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getList();
        },
        // 关闭弹窗回调
        closeCllback(isshow) {
            this.ctrl.chartsFolderVisible = false;
            this.ctrl.charts_adVisible = false;
            this.ctrl.charts_asinVisible = false;
            this.ctrl.charts_rankVisible = false;
            this.ctrl.charts_keywordVisible = false;
            if (isshow) return;
        }
    }
};
</script>
<style type="text/scss" lang="scss">
.select-popper {
    .popper__arrow {
        display: none !important;
    }
    margin-top: 3px !important;
    padding: 5px 0 !important;
    box-sizing: border-box !important;
}
.star-popper {
    padding: 3px 5px !important;
    .el-input__inner {
        height: 24px !important;
        line-height: 24px !important;
        padding: 0 8px !important;
    }
}
</style>
<style type="text/scss" lang="scss" scoped>
.amazon-choice-badge {
    background-color: #222;
    color: #fff;
    padding: 2px 5px;
    display: inline-block;
    font-size: 10px !important;
    box-sizing: border-box;
    transform: scale(0.65);
    position: relative;
    right: 16px;
    span {
        color: #e47911;
    }
}
.pen {
    cursor: pointer;
}
.pen:hover {
    text-decoration: underline;
}
.add-keywords-link {
    cursor: pointer;
    text-decoration: underline;
    color: #34495e;
    display: inline;
}
.add-keywords-link:hover {
    text-decoration: none;
    color: #23527c;
}
.fa_icon {
    font-size: 16px;
    cursor: pointer;
    margin-right: 10px;
}
.fa_icon_ {
    font-size: 18px;
    cursor: pointer;
    margin-right: 10px;
    color: #606266;
}
.keyworddelete:hover {
    color: red;
}
.line {
    display: inline-block;
}
.dropdown-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 700;
    color: #003873;
    line-height: 1.2;
    margin: 0;
    padding: 6px 8px 6px 11px;
    cursor: default;
    user-select: none;
}
.dropdown-header__title {
    font-size: 14px;
    font-weight: 600;
    color: #8c8c8c;
}
.dropdown-items {
    overflow-y: auto;
    min-height: 0;
    max-height: 276px;
    transition: height 400ms cubic-bezier(0.5, 0, 0.2, 1);
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #fff !important;
}

/deep/ ::-webkit-scrollbar {
    width: 7px;
    height: 5px;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-track-piece {
    background-color: #ffff;
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:vertical {
    height: 5px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
/deep/ ::-webkit-scrollbar-thumb:horizontal {
    width: 7px;
    background-color: rgba(144, 147, 153, 0.5);
    border-radius: 15px;
    -webkit-border-radius: 15px;
}
.dropdown-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 6px 6px 11px;
    font-size: 14px;
    font-weight: 400;
    color: #343a40;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
    box-sizing: border-box;
    .dropdown-item-txt {
        width: 132px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    span {
        padding-right: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        box-sizing: border-box;
    }
}
.dropdown-item:hover {
    background: rgb(240, 240, 240);
}
.no_folders {
    padding: 0 15px;
    font-size: 12px;
    color: #a5a8aa;
}
.folder {
    color: #003873;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6px 6px 6px 11px;
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
}
.folder:hover {
    background: rgb(240, 240, 240);
}
.check-close {
    font-size: 18px;
    cursor: pointer;
    position: relative;
    top: 2px;
    margin-left: 3px;
    font-weight: 900;
}
.star-on {
    display: flex;
    margin: 5px 0;
    align-items: center;
}
/deep/ .el-table td,
.el-table th.is-leaf {
    border-right: none;
}
.empty {
    padding: 3px 10px;
    font-weight: 400;
    color: #212529;
    font-size: 12px;
    cursor: pointer;
}
.empty:hover {
    background: rgb(240, 240, 240);
}
.icon-star {
    position: relative;
    top: -2px;
}
.checkbox-div {
    /deep/ .el-checkbox {
        width: 100%;
        display: flex;
        align-items: center;
        padding: 2.5px 10px;
    }
    /deep/ .el-checkbox:hover {
        background: rgb(240, 240, 240);
    }
    /deep/ .el-checkbox__label {
        padding-left: 5px !important;
        margin-right: 5px !important;
        display: flex;
        align-items: center;
    }
}
/deep/ .button-star {
    .el-button {
        padding: 4.2px 5.5px;
    }
    .el-button:hover {
        background: #fff !important;
    }
}
/deep/ .el-divider--horizontal {
    margin: 8px 0 4px 0 !important;
}
.button-plus {
    cursor: pointer;
    height: 28px;
    line-height: 28px;
    font-size: 13px;
    padding: 0 5.5px;
    background: #fff;
    box-sizing: border-box;
    border: 1px solid #dcdfe6;
    color: #606266;
    font-weight: 500;
    border-radius: 4px;
}
.caret-bottom {
    position: relative;
    top: -3px;
    margin-left: 3px;
}
/deep/ .highcharts-credits {
    display: none !important;
}
.chart {
    position: relative;
    overflow: visible;
    width: 100px;
    height: 36px;
    z-index: 0;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.spinner_div {
    /deep/ .el-loading-spinner {
        transform: translateY(10px);
        .circular {
            height: 20px !important;
            width: 20px !important;
        }
    }
}
.filter-block {
    background-color: #a9c7ff;
    padding: 6px 6px 6px 10px;
    font-size: 18px;
    color: #333;
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.filter-block-left {
    display: flex;
    align-items: center;
}
/deep/ .el-table--border {
    border: none;
}
</style>
